import { createGlobalStyle } from 'styled-components';
import { PREVENT_SCROLL_CLASS_NAME } from '../config/consts';
import { Header } from 'app/Components/Header/Authed/styles';
import {
  ComparisonTableForm,
  ComparisonTableRow
} from 'app/Pages/Quote/Profile/body/Quote/partials/ComparisonTable/styles';
import { PageQuote } from 'app/Pages/Quote/Profile/styles';
import {
  ComparisonTableBackButton,
  HeadContainer,
  OffersSortOrderContainer
} from 'app/Pages/Quote/Profile/body/Quote/styles';
import { ControlsButton } from '../app/Pages/Quote/Profile/body/partials/ControlsNextStep/styles';
import { ContentInnerBody } from '../app/Pages/Quote/Profile/body/styles';

export const GlobalStyles = createGlobalStyle`
  /* Reset */
  
  /* https://dev.to/hankchizljaw/a-modern-css-reset-6p3 */

  /* Box sizing rules */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  
  /* Remove default padding */
  ul[class] {
    padding: 0;
  }
  
  /* Remove default margin */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  ul[class],
  ol[class],
  li,
  figure,
  figcaption,
  blockquote,
  dl,
  dd {
    margin: 0;
  }
  
  /* Set core body defaults */
  body {
    min-height: 100vh;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
    line-height: 1;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: subpixel-antialiased;
    -webkit-print-color-adjust: exact;
    color: ${({ theme }) => theme.colors.text};
    
    @media print {
      ${ContentInnerBody} {
        @page {
          margin: 20px 0;
        }
      }
      ${ComparisonTableForm} {
        height: 100%;
        margin: 0 20px;
        padding: 0;
        overflow: hidden;
      }
      ${Header},
      ${ComparisonTableBackButton},
      ${HeadContainer},
      ${OffersSortOrderContainer},
      ${ControlsButton},
      ${PageQuote} .sidebar,
      ${ComparisonTableRow}:last-child {
          display: none;
      }
    }
  }
  
  /* Remove list styles on ul elements with a class attribute */
  ul[class] {
    list-style: none;
  }
  
  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }
  
  /* Make images easier to work with */
  img {
    max-width: 100%;
    display: block;
  }
  
  /* Natural flow and rhythm in articles by default */
  article > * + * {
    margin-top: 1em;
  }
  
  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }
  
  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  /* Outlined buttons keep their border on hover; the lib recolors it with the hover fill, which hides it */
  .qmt-ui-button.qmt-ui-button--secondary:not(:disabled):hover,
  .qmt-ui-button.qmt-ui-button--primaryOutlined:not(:disabled):hover {
    border-color: ${({ theme }) => theme.colors.buttonPreset.secondary.textHover};
  }

  /* Dialog controls app-wide: accept is primary, decline is black. The lib renders decline as secondary and accept
     with the default look; its controls row is a direct child of the dialog, so buttons inside a custom body keep their style */
  .qmt-ui-dialog > div > .qmt-ui-button:not(.qmt-ui-button--secondary) {
    background-color: ${({ theme }) => theme.colors.buttonPreset.primary.bg};
    border-color: ${({ theme }) => theme.colors.buttonPreset.primary.bg};
    color: ${({ theme }) => theme.colors.buttonPreset.primary.text};

    &:hover {
      background-color: ${({ theme }) => theme.colors.buttonPreset.primary.hover};
      border-color: ${({ theme }) => theme.colors.buttonPreset.primary.hover};
      color: ${({ theme }) => theme.colors.buttonPreset.primary.textHover};
    }
  }

  .qmt-ui-dialog > div > .qmt-ui-button.qmt-ui-button--secondary {
    background-color: ${({ theme }) => theme.colors.buttonDefaultBg};
    border-color: ${({ theme }) => theme.colors.buttonDefaultBg};
    color: ${({ theme }) => theme.colors.buttonDefaultText};

    &:hover {
      background-color: ${({ theme }) => theme.colors.buttonDefaultHover};
      border-color: ${({ theme }) => theme.colors.buttonDefaultHover};
      color: ${({ theme }) => theme.colors.buttonDefaultText};
    }
  }

  /* Helpers */

  .${PREVENT_SCROLL_CLASS_NAME} {
    overflow: hidden !important;
  }
`;
